module.exports = __webpack_public_path__ + "static/media/bag_with_flower-p10.4fd8092a.gif";